import { connect } from 'react-redux';
import DismantleMrf from "./mrf";
import { bindActionCreators } from 'redux';
import {getDismantleSite, getDismantleMrf, contractDate} from "../../../../services/redux/installation/siteListing/action";
import {fetchSubCategoryType} from "../../../../services/redux/maintenance/pmList/action";

const mapStateToProps = (state) => ({
    dismantleSiteResponse: state.siteListingReducer.dismantleSiteResponse,
    dismantleMrfResponse: state.siteListingReducer.dismantleMrfResponse,
    contractDateResponse: state.siteListingReducer.contractDateResponse,
    subCategoryType: state.pmListReducer.subCategoryType,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            getDismantleSite,
            fetchSubCategoryType,
            getDismantleMrf,
            contractDate
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(DismantleMrf);
